<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Banner from 'dashboard/components-next/banner/Banner.vue';
import ChannelSyncConfirmDialog from './ChannelSyncConfirmDialog.vue';

defineProps({
  conversationId: { type: Number, required: true },
  channelSync: { type: Object, required: true },
});

const { t } = useI18n();
const confirmationDialog = ref(null);
</script>

<template>
  <Banner
    color="amber"
    class="mx-2 mb-2"
    :action-label="t('CONVERSATION.CHANNEL_SYNC.RESTORE')"
    @action="confirmationDialog.open()"
  >
    {{ t('CONVERSATION.CHANNEL_SYNC.DISABLED_MESSAGE') }}
  </Banner>
  <ChannelSyncConfirmDialog
    ref="confirmationDialog"
    :conversation-id="conversationId"
    :channel-sync="channelSync"
  />
</template>
